import comparisonMiddleware from './middleware';
import comparisonReducer, { comparisonAdapter, comparisonSlice } from './reducer';
import * as selectors from './selectors';

const comparisonActions = {
  ...comparisonSlice.actions,
};

const comparisonSelectors = {
  ...selectors,
  ...comparisonAdapter.getSelectors(),
};

export {
  comparisonActions,
  comparisonMiddleware,
  comparisonReducer,
  comparisonSelectors,
};
